import { BaseController } from '~client/controller/base-controller';
import { ExternalPaymentRequest, ExternalPaymentResponse } from '~client/model/external-payment';
import { PurchaseResponse } from '~client/model/purchase-response';

/* APIs to support external payments like Alipay/WeChatPay */
export class ExternalPaymentCallbackController extends BaseController {
  /* Starts a purchase flow using an external payment (e.g. QR payments) */
  public initiateExternalPayment(
    request: ExternalPaymentRequest,
  ): Promise<ExternalPaymentResponse> {
    return this.post('/payment/external/cart/initiateExternalPayment', request);
  }

  /* User callback endpoint for external purchases */
  public purchase(signedExternalPaymentKey: string): Promise<PurchaseResponse> {
    return this.post(
      `/payment/external/user/purchase?signedExternalPaymentKey=${signedExternalPaymentKey}`,
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/external-payment-callback-controller.tsx